import { createStore, compose } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

// import the root reducer
import rootReducer from './reducers/index';

import player_list from './data/player_list3';
import pick_list from './data/pick_list3';

const means = pick_list.map(function (x) {return x.P90});
const values = player_list.map(function (x) {return x.value});

// create object for default data
// TODO: combine picks available/traded sections
const defaultState = {
  trade: {
    playerSent: [],
    playerRec: [],
    sentValue: 0,
    recValue: 0,
    pickSent: [],
    pickRec: [],
    picksAvailable: means,
    playersAvailable: values,
    kept: [],
    bestPick: means[0],
    bestPlayer: values[0],
    chopped:[],
    leagueSize: 12
  }
};

//const enhancers = compose(
  //window.devToolsExtension ? window.devToolsExtension() : f => f
//);

//const store = createStore(rootReducer, defaultState, enhancers);
const store = createStore(rootReducer, defaultState);

export const history = syncHistoryWithStore(browserHistory, store);

if (module.hot) {
  module.hot.accept('./reducers/', () => {
    const nextRootReducer = require('./reducers/index').default;
    store.replaceReducer(nextRootReducer);
  });
}
export default store;



// WEBPACK FOOTER //
// ./src/store.js